import { useState } from "react";
import useLogin from "hooks/useLogin";
import { GoogleOAuthProvider, GoogleLogin } from "@react-oauth/google";

function Login() {
  const { handleGoogleLoginSuccess, handleEmailPasswordLogin } = useLogin();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleLoginClick = () => {
    if (!email || !password) {
      alert("Please fill in both email and password.");
      return;
    }
    handleEmailPasswordLogin(email, password); // Call email/password login
  };

  return (
    <div className="h-screen flex justify-center items-center bg-cover bg-center bg-gray-100">
      <div className="bg-white shadow-lg rounded-lg text-center p-8 border border-gray-300 opacity-95 w-full py-40 sm:w-[380px]">
        {/* Title */}
        <h1 className="text-2xl font-semibold pb-4 text-gray-800 mb-20">
          Login
        </h1>

        {/* Email and Password Login */}
        <div className="mb-6 space-y-4">
          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="block w-full px-4 py-3 text-md border rounded-md border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 my-10"
          />
          <div className="relative">
            <input
              type={showPassword ? "text" : "password"}
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="block w-full px-4 py-3 text-md border rounded-md border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 my-10"
            />
            <button
              type="button"
              onClick={togglePasswordVisibility}
              className="absolute right-4 top-1/2 transform -translate-y-1/2 text-xl text-gray-500"
            >
              {showPassword ? "👁" : "🔒"}
            </button>
          </div>

          {/* Login Button */}
          <button
            onClick={handleLoginClick}
            className="w-full py-3 bg-blue-500 text-white rounded-md hover:bg-blue-600 text-lg font-medium transition duration-200"
          >
            Login
          </button>
        </div>

        <div className="mt-10 align-middle justify-center flex ">
          <GoogleOAuthProvider clientId="780666816292-mfs9ujrcuqnlu65fmdekceudsf1qmtpq.apps.googleusercontent.com">
            <GoogleLogin
              onSuccess={handleGoogleLoginSuccess}
              onError={() => {
                alert("Google Login Failed");
              }}
              useOneTap
              shape="rectangular"
              size="large"
              width="100%"
            />
          </GoogleOAuthProvider>
        </div>
        {/* Google Login */}
      </div>
    </div>
  );
}


export default Login;